"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Fraserland Organics
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 2.1.10-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpBodyToJSON = exports.SignUpBodyFromJSONTyped = exports.SignUpBodyFromJSON = void 0;
const runtime_1 = require("../runtime");
function SignUpBodyFromJSON(json) {
    return SignUpBodyFromJSONTyped(json, false);
}
exports.SignUpBodyFromJSON = SignUpBodyFromJSON;
function SignUpBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userName': json['userName'],
        'password': json['password'],
        'confirmPassword': json['confirmPassword'],
        'firstName': !runtime_1.exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !runtime_1.exists(json, 'lastName') ? undefined : json['lastName'],
    };
}
exports.SignUpBodyFromJSONTyped = SignUpBodyFromJSONTyped;
function SignUpBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userName': value.userName,
        'password': value.password,
        'confirmPassword': value.confirmPassword,
        'firstName': value.firstName,
        'lastName': value.lastName,
    };
}
exports.SignUpBodyToJSON = SignUpBodyToJSON;
